import styles from "./signinbutton.module.css";

interface Props {
  isInMenu?: boolean;
  isLoginPage?: boolean;
  handleOnClick?: () => void;
}

export default function SignInButton({ isInMenu: darkBackground, isLoginPage, handleOnClick }: Props) {
  return (
      <button type="button" className={`${styles.signInButton} ${darkBackground ? styles.menuStyle : ''} ${isLoginPage && styles.loginPage}`} onClick={handleOnClick}>Sign In</button>
  );
}
